import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { I18nextProvider } from 'react-i18next';

import i18n from './i18n';
import App from './App';

import FooterLayout from '@/components/FooterLayout';
import './styles/main.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <I18nextProvider i18n={i18n} defaultNS={'translation'}>
      <div className="app-content">
        <App />
      </div>
      <FooterLayout/>
    </I18nextProvider>
  </BrowserRouter>,
);
